


import SECTION_BOARDGAMEBANNERSECTION from
'../dynamic_section/dynamic_2/template_01';





import SECTION_BOARDGAMECONTAINERSECTION from
'../dynamic_section/dynamic_1/template_01';





import SECTION_FOOTER_BANNER from
'../dynamic_section/dynamic_2/template_01';



import "./style.css";


const BoardGamePageDesktop = ()=>{
  
return (
  <div id="boardGamePageDesktop" class="page ">
  
  

  
  < SECTION_BOARDGAMEBANNERSECTION desktopToggle={ true }
    mobileToggle={ false } label={ `boardgame_game_banner` } id={ `boardgame_banner` } supportLanguage={
    true } titleToggle={ false } titleIconToggle={
    true } linkTo={ `` } addContainer={ false } />
  
  
  
  

  
  < SECTION_BOARDGAMECONTAINERSECTION desktopToggle={ true }
    mobileToggle={ false } label={ `Section_boardgame` } id={ `boardGameContainer` }
    imageSize={`2x1`} contentPosition={`bottom`}
    actionPosition={``} rowDesktop={ 7 }
    rowMobile={ 3 } numberOfRow={ -1 }
    dataType={`game provider`} noPadding={ false } filter={`CB`}
    titleToggle={ false } titleIconToggle={ true }
    cardPosition={`start`} pagination={ true }
    autoplay={ true } navigation={ true }
    dynamicQuery={`` } filterTabToggle={ false }
    folderImage={``} noLink={ false }/>
  
  
  
  

  
  < SECTION_FOOTER_BANNER desktopToggle={ true }
    mobileToggle={ false } label={ `Dynamic Section2` } id={ `footer_banner` } supportLanguage={
    true } titleToggle={ false } titleIconToggle={
    true } linkTo={ `` } addContainer={ false } />
  
  
  

  
</div>
)
}

export default BoardGamePageDesktop;